export const FETCH_COMMENTS = 'src/components/Cases/View/action/Fetch_Comments';
export const FETCH_COMMENTS_SUCCESS = 'src/components/Cases/View/action/Fetch_Comments_Success';
export const FETCH_COMMENTS_FAILURE = 'src/components/Cases/View/action/Fetch_Comments_Failure';
export const fetchComments = (data) => {
    return {
        type: FETCH_COMMENTS,
        data
    }
}

export const fetchCommentsSuccess = (data) => {
    return {
        type: FETCH_COMMENTS_SUCCESS,
        data
    }
}
export const fetchCommentsFailure = (error) => {
    return {
        type: FETCH_COMMENTS_FAILURE,
        error
    }
}

export const POST_COMMENTS = 'src/components/Cases/View/action/Post_Comments';
export const POST_COMMENTS_SUCCESS = 'src/components/Cases/View/action/Post_Comments_Success';
export const POST_COMMENTS_FAILURE = 'src/components/Cases/View/action/Post_Comments_Failure';
export const postComments = (data, reqBody) => {
    return {
        type: POST_COMMENTS,
        data,
        reqBody
    }
}

export const postCommentsSuccess = (data) => {
    return {
        type: POST_COMMENTS_SUCCESS,
        data
    }
}
export const postCommentsFailure = (error) => {
    return {
        type: POST_COMMENTS_FAILURE,
        error
    }
}

export const COMMENT_READ_STATUS = 'src/components/Cases/View/action/Comment_Read_Status';
export const COMMENT_READ_STATUS_SUCCESS = 'src/components/Cases/View/action/Comment_Read_Status_Success';
export const COMMENT_READ_STATUS_FAILURE = 'src/components/Cases/View/action/Comment_Read_Status_Failure';

export const commentReadStatus = (data) => {
    return {
        type: COMMENT_READ_STATUS,
        data
    }
}
export const commentReadStatusSuccess = (data) => {
    return {
        type: COMMENT_READ_STATUS_SUCCESS,
        data
    }
}

export const commentReadStatusFailure = (data) => {
    return {
        type: COMMENT_READ_STATUS_FAILURE,
        data
    }
}

export const FETCH_AGGREGATE_TYPES = 'src/components/Cases/View/action/Fetch_Aggregate_Types';
export const FETCH_AGGREGATE_TYPES_SUCCESS = 'src/components/Cases/View/action/Fetch_Aggregate_Types_Success';
export const FETCH_AGGREGATE_TYPES_FAILURE = 'src/components/Cases/View/action/Fetch_Aggregate_Types_Failure';
export const fetchAggregateTypes = (data) => {
    return {
        type: FETCH_AGGREGATE_TYPES,
        data
    }
}
export const fetchAggregateTypesSuccess = (data) => {
    return {
        type: FETCH_AGGREGATE_TYPES_SUCCESS,
        data
    }
}
export const fetchAggregateTypesFailure = (data) => {
    return {
        type: FETCH_AGGREGATE_TYPES_FAILURE,
        data
    }
}
export const FETCH_AGGREGATE_DIRECTIONS = 'src/components/Cases/View/action/Fetch_Aggregate_Directions';
export const FETCH_AGGREGATE_DIRECTIONS_SUCCESS = 'src/components/Cases/View/action/Fetch_Aggregate_Directions_Success';
export const FETCH_AGGREGATE_DIRECTIONS_FAILURE = 'src/components/Cases/View/action/Fetch_Aggregate_Directions_Failure';
export const fetchAggregateDirections = (data) => {
    return {
        type: FETCH_AGGREGATE_DIRECTIONS,
        data
    }
}
export const fetchAggregateDirectionsSuccess = (data) => {
    return {
        type: FETCH_AGGREGATE_DIRECTIONS_SUCCESS,
        data
    }
}
export const fetchAggregateDirectionsFailure = (data) => {
    return {
        type: FETCH_AGGREGATE_DIRECTIONS_FAILURE,
        data
    }
}
export const FETCH_DATA_TYPES = 'src/components/Cases/View/action/Fetch_Data_Types';
export const FETCH_DATA_TYPES_SUCCESS = 'src/components/Cases/View/action/Fetch_Data_Types_Success';
export const FETCH_DATA_TYPES_FAILURE = 'src/components/Cases/View/action/Fetch_Data_Types_Failure';
export const fetchDataTypes = (data) => {
    return {
        type: FETCH_DATA_TYPES,
        data
    }
}
export const fetchDataTypesSuccess = (data) => {
    return {
        type: FETCH_DATA_TYPES_SUCCESS,
        data
    }
}
export const fetchDataTypesFailure = (data) => {
    return {
        type: FETCH_DATA_TYPES_FAILURE,
        data
    }
}

export const FETCH_RISKGRADE_CATEGORY_LIST = 'src/Admin/Corporate/Create/action/Fetch_Riskgrade_Category_List';
export const FETCH_RISKGRADE_CATEGORY_LIST_SUCCESS = 'src/Admin/Corporate/Create/action/Fetch_Riskgrade_Category_List_Success';
export const FETCH_RISKGRADE_CATEGORY_LIST_FAILURE = 'src/Admin/Corporate/Create/action/Fetch_Riskgrade_Category_List_Failure';

export const fetchRiskgradeCategory = () => {
    return {
        type: FETCH_RISKGRADE_CATEGORY_LIST
    }
}
export const fetchRiskgradeCategorySuccess = (data) => {
    return {
        type: FETCH_RISKGRADE_CATEGORY_LIST_SUCCESS,
        data
    }
}
export const fetchRiskgradeCategoryFailure = (error) => {
    return {
        type: FETCH_RISKGRADE_CATEGORY_LIST_FAILURE,
        error
    }
}

export const GET_SELECTED_COUNTRY_STATES = 'src/Admin/component/Services/action/Get_Selected_Country_States';
export const GET_SELECTED_COUNTRY_STATES_SUCCESS = 'src/Admin/component/Services/action/Get_Selected_Country_States_Success';
export const GET_SELECTED_COUNTRY_STATES_FAILURE = 'src/Admin/component/Services/action/Get_Selected_Country_States_Failure';

export const getSelectedCountryStates = (data) => {
    return {
        type: GET_SELECTED_COUNTRY_STATES,
        data
    }
}

export const getSelectedCountryStatesSuccess = (data) => {
    return {
        type: GET_SELECTED_COUNTRY_STATES_SUCCESS,
        data
    }
}

export const getSelectedCountryStatesFailure = (data) => {
    return {
        type: GET_SELECTED_COUNTRY_STATES_FAILURE,
        data
    }
}

export const FETCH_CORPORATE_DETAILS = 'src/Admin/component/Services/action/Fetch_Corporates_Details';
export const FETCH_CORPORATE_DETAILS_SUCCESS = 'src/Admin/component/Services/action/Fetch_Corporates_Details_Success';
export const FETCH_CORPORATE_DETAILS_FAILURE = 'src/Admin/component/Services/action/Fetch_Corporates_Details_Failure';


export const getCoporateDetails = (data) => {
    return {
        type: FETCH_CORPORATE_DETAILS,
        data
    }
}

export const getCoporateDetailsSuccess = (data) => {
    return {
        type: FETCH_CORPORATE_DETAILS_SUCCESS,
        data
    }
}

export const getCoporateDetailsFailure = (data) => {
    return {
        type: FETCH_CORPORATE_DETAILS_FAILURE,
        data
    }
}